import styled from "styled-components";
import { COLORS, Typo } from "../../layout/theme/index.js";

export const LoaderContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 30px 25px;
	text-align: center;
	gap: 16px;
	background: linear-gradient(135deg, #fafbff 0%, #ffffff 100%);
	border-radius: 8px;

	.ant-progress {
		width: 100%;
		margin: 8px 0;
		
		.ant-progress-bg {
			transition: all 0.4s ease;
			border-radius: 10px;
		}
		
		.ant-progress-outer {
			.ant-progress-inner {
				border-radius: 10px;
				background-color: #f5f5f5;
			}
		}
	}

	@media (max-width: 768px) {
		padding: 25px 20px;
		gap: 14px;
	}
`;

export const MainMessage = styled(Typo).attrs({ level: 3 })`
	color: ${COLORS.Primary};
	font-weight: 600;
	margin: 0;
	line-height: 1.4;
`;

export const SubMessage = styled(Typo).attrs({ level: 5 })`
	color: ${COLORS.MediumGrey};
	margin: 0;
	font-style: italic;
`;

export const IconContainer = styled.div`
	font-size: 48px;
	margin-bottom: 10px;
	animation: pulse 2s infinite;
	filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));

	@keyframes pulse {
		0% {
			transform: scale(1);
			opacity: 1;
		}
		50% {
			transform: scale(1.1);
			opacity: 0.8;
		}
		100% {
			transform: scale(1);
			opacity: 1;
		}
	}

	@media (max-width: 768px) {
		font-size: 40px;
	}
`;

export const StepIndicator = styled(Typo).attrs({ level: 4 })`
	color: ${COLORS.Secondary};
	font-weight: 500;
	margin: 0;
	font-style: italic;
	opacity: 0.9;
	transition: all 0.3s ease;

	@media (max-width: 768px) {
		font-size: 14px;
	}
`;

export const TimeEstimate = styled(Typo).attrs({ level: 5 })`
	color: ${COLORS.MediumGrey};
	margin: 0;
	font-weight: 500;
	background: rgba(24, 144, 255, 0.08);
	padding: 6px 12px;
	border-radius: 16px;
	border: 1px solid rgba(24, 144, 255, 0.15);
	transition: all 0.3s ease;
	font-size: 13px;

	@media (max-width: 768px) {
		font-size: 12px;
		padding: 5px 10px;
	}
`;

export const TipContainer = styled.div`
	background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
	border-radius: 8px;
	padding: 14px 18px;
	margin: 8px 0;
	min-height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-left: 3px solid ${COLORS.Secondary};
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
	transition: all 0.3s ease;
	position: relative;
	overflow: hidden;

	p {
		margin: 0;
		font-size: 13px;
		color: ${COLORS.DarkGrey};
		line-height: 1.5;
		font-weight: 500;
		animation: fadeIn 0.4s ease-in-out;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(8px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@media (max-width: 768px) {
		padding: 12px 16px;
		min-height: 45px;
		
		p {
			font-size: 12px;
		}
	}
`;
